import { getFilteredData } from '~packages/epk-front-shared/api-client';
import type { Filters, Params } from '~packages/epk-front-shared/api-client';

import BigIntModuleApiService from './BigIntModuleApiService';

export default class EpkModuleApiService extends BigIntModuleApiService {
  constructor(params = {}) {
    super({ ...params, pathFetchAll: '/', pathAdd: '/' });
  }

  async getFilteredData(filters: Filters, params: Params) {
    return await getFilteredData(this, filters, params);
  }
}
